"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ResultsList;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("../search-terms-list/index"));
/* eslint-disable complexity */

/**
 * Results List component.
 * @module ResultsList
 *
 * @param {Object} props React props
 * @param {String} props.title Results title
 * @returns {React.ReactElement} ResultsList component
 * @public
 */
function ResultsList({
  title
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": `results-list`
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    suggestedSearchesHeadline: title,
    step: "initial"
  }));
}
ResultsList.propTypes = {
  title: _propTypes.default.string
};